import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { fetchConfig } from "./config/config";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Prefetch data before rendering
fetchConfig().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
